import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { describe } from '@amzn/stencil-react-desc';
import { StencilConsumer } from "../context";
import { Container } from "../layout";
import { omit, withTestAttributes } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";

var PageContainerBase = function PageContainerBase(containerProps) {
  return ___EmotionJSX(StencilConsumer, null, function (_ref) {
    var selectors = _ref.selectors;
    return ___EmotionJSX(Container, _extends({
      paddingHorizontal: selectors.constant('pageHorizontalPadding')
    }, containerProps));
  });
};

PageContainerBase.defaultProps = _objectSpread(_objectSpread({}, omit(Container.defaultProps, ['paddingHorizontal'])), {}, {
  paddingTop: 'S600',
  paddingBottom: 'S700'
});
var PageContainerWithDocs = describe(PageContainerBase).description('Page container with consistent padding and maximum width.');
PageContainerWithDocs.propTypes = _objectSpread({}, Container.describedPropTypes);
export var PageContainer = withTestAttributes({
  id: 'StencilReactPageContainer'
})(PageContainerWithDocs);
PageContainer.displayName = 'PageContainer';